import { SchedulesContainer } from './SchedulesContainer';

const name = 'SchedulesContainer';

export { SchedulesContainer, name };
